export function getActiveCertification({
  activatedAt,
  certificationVerified,
  certificationCertified,
}: {
  activatedAt: string;
  certificationVerified: boolean;
  certificationCertified: boolean;
}): 'certified' | 'verified' | 'validated' | undefined {
  // Check certifications in priority order (highest to lowest)
  if (certificationCertified) return 'certified';
  if (certificationVerified) return 'verified';
  if (activatedAt) return 'validated';

  return undefined;
}
